import { Col3Col9, Radio } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../../../contentConstants';
import { LabelAbove } from '../../common';
import { SsoAttribute } from '../../../models/SsoAttribute';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../../store';
import { ActionCreators } from '../../../store/AudienceDetailsStore';
import { useEffect } from 'react';

const SsoAttributeSectionContainer = styled.div`
	padding-top: 40px;
	padding-bottom: 20px;
`;

const ssoAttributeRadioOptions = Object.keys(SsoAttribute)
	.filter((key) => !isNaN(Number(key)))
	.map((key) => ({
		name: key,
		displayText: SsoAttribute[key],
		checked: false,
	}));

export const SsoAttributeSection = () => {
	const { audience } = useSelector((state: IApplicationState) => state.audienceDetails);
	const { distributions } = useSelector((state: IApplicationState) => state.distributionList);
	const dispatch = useDispatch();
	const selectedSsoAttribute = audience.ssoAttributeId?.toString();
	// IF there is at least one saved distribution file disable the attribute selection to stop the user from changing it
	const savedDistributionFile = distributions.find((_) => _.distributionFileId > 0);

	useEffect(() => {
		if (!selectedSsoAttribute) {
			onChangeHandler(SsoAttribute.EmployeeId);
		}
	}, []);

	return (
		<SsoAttributeSectionContainer>
			<Col3Col9 label={ContentConstants.SSO_IDENTIFIER_SECTION_TITLE} labelSize='lg' className='tws-sso-attribute-section'>
				<LabelAbove type='input' text={ContentConstants.INSTRUCTIONALTEXT_SSO_IDENTIFIER} />
				<Radio
					name='ssoAttributes'
					items={ssoAttributeRadioOptions}
					value={selectedSsoAttribute ?? SsoAttribute.EmployeeId.toString()}
					alignDirection='Horizontal'
					onChange={onChangeHandler}
					disabled={savedDistributionFile !== undefined}
				/>
			</Col3Col9>
		</SsoAttributeSectionContainer>
	);

	function onChangeHandler(value: SsoAttribute) {
		dispatch(ActionCreators.HandleSsoAttributeSelectionChange(value));
	}
};
